import React from "react";
import { Navigate } from "react-router-dom";


const AdminProtectedRoute = ({ component: Component, ...rest }) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const is_Auth = userDetails?.token;
    const allowedRoles = ["ADMIN", "ZM", "AE"];
    const is_Allowed = allowedRoles.includes(userDetails?.role);

    return is_Auth && is_Allowed ? <Component {...rest} /> : <Navigate to="/" />;
};

export default AdminProtectedRoute;
